export const CUSTOMER_ATTENTION_SEVERITY = Object.freeze({
  OK: 'OK',
  ATTENTION: 'ATTENTION',
  URGENT: 'URGENT',
});

export const CUSTOMER_ATTENTION_PRESENTATION = Object.freeze({
  [CUSTOMER_ATTENTION_SEVERITY.OK]: Object.freeze({
    label: 'All good',
    heading: 'Nothing currently needs your attention',
    description: 'Your bots will continue checking market data. This status refers only to actions you may need to take, not investment performance.',
    sectionClass: 'border-emerald-300 bg-emerald-50 dark:border-emerald-800 dark:bg-emerald-950/30',
    labelClass: 'text-emerald-700 dark:text-emerald-300',
    badgeClass: 'bg-emerald-200 text-emerald-900 dark:bg-emerald-900 dark:text-emerald-100',
    itemClass: 'border-emerald-200 dark:border-emerald-800',
    iconClass: 'text-emerald-600 dark:text-emerald-300',
    briefingClass: 'bg-emerald-50 dark:bg-emerald-950/30',
  }),
  [CUSTOMER_ATTENTION_SEVERITY.ATTENTION]: Object.freeze({
    label: 'Needs your attention',
    heading: 'Items to review',
    description: 'Review the open items below. A watch condition is an analysis result, not a trade or an order.',
    sectionClass: 'border-amber-300 bg-amber-50 dark:border-amber-800 dark:bg-amber-950/30',
    labelClass: 'text-amber-700 dark:text-amber-300',
    badgeClass: 'bg-amber-200 text-amber-900 dark:bg-amber-900 dark:text-amber-100',
    itemClass: 'border-amber-300 dark:border-amber-800',
    iconClass: 'text-amber-600 dark:text-amber-300',
    briefingClass: 'bg-amber-50 dark:bg-amber-950/30',
  }),
  [CUSTOMER_ATTENTION_SEVERITY.URGENT]: Object.freeze({
    label: 'Action required',
    heading: 'Time-sensitive items need review',
    description: 'Review the open items below before their deadlines. A strategy condition alone cannot place an order.',
    sectionClass: 'border-rose-300 bg-rose-50 dark:border-rose-800 dark:bg-rose-950/30',
    labelClass: 'text-rose-700 dark:text-rose-300',
    badgeClass: 'bg-rose-200 text-rose-900 dark:bg-rose-900 dark:text-rose-100',
    itemClass: 'border-rose-300 dark:border-rose-800',
    iconClass: 'text-rose-600 dark:text-rose-300',
    briefingClass: 'bg-rose-50 dark:bg-rose-950/30',
  }),
});

export const customerAttentionPresentation = (severity) => (
  CUSTOMER_ATTENTION_PRESENTATION[severity]
  || CUSTOMER_ATTENTION_PRESENTATION[CUSTOMER_ATTENTION_SEVERITY.ATTENTION]
);
